import { render, staticRenderFns } from "./FormSubHeaders.vue?vue&type=template&id=7e91f514&scoped=true&"
import script from "./FormSubHeaders.vue?vue&type=script&lang=js&"
export * from "./FormSubHeaders.vue?vue&type=script&lang=js&"
import style0 from "./FormSubHeaders.vue?vue&type=style&index=0&id=7e91f514&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e91f514",
  null
  
)

export default component.exports